import React, { useState } from 'react';
import SubAdminModal from '../../components/shared/subAdminModal';
import DeleteIcon from '../../assets/icons/delete.svg';
import ConfirmationModal from '../../components/modals/confirmationModal';
import AccessManagementTable from '../../components/shared/AccessManagementTable';
import AuditLogsTable from '../../components/shared/AuditLogsTable';

const styles = {
	mainButton:
		'inline-flex items-center space-x-2 bg-dark-blue max-w-[210px] h-[52px] py-5 px-4 text-base font-semibold leading-100 text-white rounded-md cursor-pointer'
};

export default function AccessManagementPage() {
	const [subAdminModalOpen, setSubAdminModalOpen] = useState(false);
	const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
	const [isModalEditMode, setIsModalEditMode] = useState(false);
	const [currentSubAdminData, setCurrentSubAdminData] = useState(null);
	const [subAdminToDelete, setSubAdminToDelete] = useState(null);
	const accessUsers = [
		{ name: 'Majid Ali', email: 'majidali@nesl-it.com', role: 'Sub-admin', status: 'ACTIVE' },
		{
			name: 'Haseeb Ahmed',
			email: 'muhammadhaseeb@nesl-it.com',
			role: 'Sub-admin',
			status: 'ACTIVE'
		},
		{ name: 'Zunair Khan', email: 'zunairkhan@nesl-it.com', role: 'Sub-admin', status: 'IN-ACTIVE' }
	];

	const auditLogs = [
		{
			activity: 'Logged in',
			comment: 'Logged into the sub-admin',
			email: 'majidali@nesl-it.com',
			datetime: '01 July, 2025 - 14:30'
		},
		{
			activity: 'Resolve query',
			comment: 'Resolved query #0981',
			email: 'muhammadhaseeb@nesl-it.com',
			datetime: '04 July, 2025 - 09:23'
		}
	];

	const handleDelete = () => {
		//API Logic for delete
		setDeleteConfirmationModalOpen(false);
	};

	const handleEditSubAdmin = (user) => {
		setSubAdminModalOpen(true);
		setIsModalEditMode(true);
		setCurrentSubAdminData(user);
	};

	const handleDeleteSubAdmin = (user) => {
		setDeleteConfirmationModalOpen(true);
		setSubAdminToDelete(user);
	};

	return (
		<div className="md:py-4 bg-bgColor">
			<div className="flex justify-between flex-col md:flex-row items-center mb-12">
				<div>
					<h1 className="text-dark-blue font-bold text-main leading-100 md:mb-0 mb-5">
						Access Management
					</h1>
				</div>

				<div>
					<button
						className={styles.mainButton}
						onClick={() => {
							setSubAdminModalOpen(true);
							setIsModalEditMode(false);
							setCurrentSubAdminData(null);
						}}
					>
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6.5625 0.875C6.5625 0.391016 6.17148 0 5.6875 0C5.20352 0 4.8125 0.391016 4.8125 0.875V4.8125H0.875C0.391016 4.8125 0 5.20352 0 5.6875C0 6.17148 0.391016 6.5625 0.875 6.5625H4.8125V10.5C4.8125 10.984 5.20352 11.375 5.6875 11.375C6.17148 11.375 6.5625 10.984 6.5625 10.5V6.5625H10.5C10.984 6.5625 11.375 6.17148 11.375 5.6875C11.375 5.20352 10.984 4.8125 10.5 4.8125H6.5625V0.875Z"
								fill="white"
							/>
						</svg>
						<span>Add new sub-admin</span>
					</button>
				</div>
			</div>

			<h2 className="text-[22px] leading-100 font-medium text-dark-blue mb-12">
				Access management
			</h2>
			<AccessManagementTable
				accessUsers={accessUsers}
				onEditSubAdmin={handleEditSubAdmin}
				onDeleteSubAdmin={handleDeleteSubAdmin}
			/>

			<AuditLogsTable heading={"Audit logs"} auditLogs={auditLogs} />

			<SubAdminModal
				isOpen={subAdminModalOpen}
				onClose={() => setSubAdminModalOpen(false)}
				isEdit={isModalEditMode}
				initialFirstName={currentSubAdminData?.name.split(' ')[0]}
				initialLastName={currentSubAdminData?.name.split(' ')[1]}
				initialEmail={currentSubAdminData?.email}
			/>

			<ConfirmationModal
				isOpen={deleteConfirmationModalOpen}
				onClose={() => setDeleteConfirmationModalOpen(false)}
				icon={<img src={DeleteIcon} alt="Delete" className="mx-auto" />}
				heading="Deleting sub-admin"
				description={
					<>
						Are you sure you want to delete{' '}
						<span className="text-dark-blue font-medium">{subAdminToDelete?.name}</span> from
						sub-admins?
					</>
				}
				primaryButtonText="Cancel"
				secondaryButtonText="Delete"
				onPrimaryClick={() => setDeleteConfirmationModalOpen(false)}
				onSecondaryClick={handleDelete}
			/>
		</div>
	);
}
